import { type AvatarCardWrapperQuery } from '#app/__generated__/relay/AvatarCardWrapperQuery.graphql.js';
import { formatName } from '#app/utilities/formatName.js';
import { AvatarCard } from './AvatarCard.js';
import { graphql, useLazyLoadQuery } from '@contra/relay';

type AvatarCardWrapperProps = {
  readonly displayUsername: string;
};

export const AvatarCardWrapper = ({
  displayUsername,
}: AvatarCardWrapperProps) => {
  const { userProfileByUsername: userProfile } =
    useLazyLoadQuery<AvatarCardWrapperQuery>(
      graphql`
        query AvatarCardWrapperQuery($username: String!) {
          userProfileByUsername(username: $username) {
            id
            firstName
            lastName
            isRemovedFromClientWorkspace
            avatarImage {
              id
              url
              uid
            }
            portfolioProjects(first: 2) {
              ...AvatarCard_projects
            }
          }
        }
      `,
      {
        username: displayUsername,
      },
    );

  return (
    <AvatarCard
      avatarImage={{
        ...userProfile?.avatarImage,
        id: userProfile?.avatarImage?.id ?? '',
        uid: userProfile?.avatarImage?.uid ?? '',
        url: userProfile?.avatarImage?.url ?? '',
      }}
      deactivated={userProfile?.isRemovedFromClientWorkspace ?? false}
      displayUsername={displayUsername}
      portfolioProjects={userProfile?.portfolioProjects}
      userName={formatName(
        { firstName: userProfile?.firstName, lastName: userProfile?.lastName },
        'fullName',
      )}
    />
  );
};
